import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DataRoomShareableLink } from 'models/ShareableLink';
import ThreeDotsDropdown from 'components/ThreeDotsDropdown';
import { ALIGNMENT } from 'models/Global';
import {
  CreatedCell,
  FilesCell,
  NumberAcessCell,
  ProtectionCell,
  VisitsCell,
} from '../../../ShareableLinksTable/components';
import useGetShareableLinkActionOptions from '../../../../hooks/useGetShareableLinkActionOptions';
import { getRowBackgroundColor } from '../../../../utils';
import SecureLinkAnalytics from '../../../SecureLinkAnalytics';
import { getIsArrayEmpty } from 'utils';
import ShareableLinkName from '../../../SecureLinkAnalytics/components/ShareableLinkName';

import './ShareableLinksMobileItem.styles.scss';

type ShareableLinksMobileItemProps = {
  className?: string;
  isExpanded: boolean;
  link: DataRoomShareableLink;
  updateShareableLink: (link: DataRoomShareableLink) => void;
  onAfterToggleState?: (linkBeforeToggle: DataRoomShareableLink) => void;
  onRowClick: (link: DataRoomShareableLink) => void;
};

const ShareableLinksMobileItem: React.FC<ShareableLinksMobileItemProps> = (
  props,
) => {
  const {
    className,
    link,
    isExpanded,
    updateShareableLink,
    onAfterToggleState,
    onRowClick,
  } = props;
  const { fileIds } = link;

  const isEmpty = getIsArrayEmpty(fileIds);

  const color = getRowBackgroundColor(link);

  const classes = classNames('shareable-links-mobile-item', color, className);

  const { t } = useTranslation();

  const { options, prolongShareableLinkModal, activateSecureLinkModal } =
    useGetShareableLinkActionOptions({
      link,
      updateShareableLink,
      onAfterToggleState,
    });

  return (
    <>
      <div className={classes} onClick={() => onRowClick(link)}>
        <div className="row">
          <ShareableLinkName link={link} />

          <div className="actions" onClick={(e) => e.stopPropagation()}>
            <ThreeDotsDropdown
              renderAsPortal
              withBorder={false}
              alignment={ALIGNMENT.VERTICAL}
              options={options}
            />
          </div>
        </div>

        <NumberAcessCell link={link} />

        <div className="row">
          <div className="access">
            {t('created')}
            {' : '}
            <CreatedCell link={link} />
          </div>

          <div className="access">
            {t('visitsUC')}
            {' : '}
            <VisitsCell link={link} />
          </div>
        </div>

        <div className="row">
          <ProtectionCell
            link={link}
            updateShareableLink={updateShareableLink}
          />
          {isEmpty && <FilesCell link={link} />}
        </div>

        {prolongShareableLinkModal}
        {activateSecureLinkModal}
      </div>
      {isExpanded && <SecureLinkAnalytics link={link} />}
    </>
  );
};

export default ShareableLinksMobileItem;
